import { useContext } from 'react'
import { EditorStateContext } from '../EditorProviderContext'

export const useEditorState = () => {
  const context = useContext(EditorStateContext)

  if (!context) {
    throw new Error(`useEditorState is only available inside EditorProvider`)
  }

  return context
}
